module.exports = __webpack_public_path__ + "img/work1.50e9d023.png";